import type { CpeRouterAssignment } from "../requests/request";

/**
 * The line a CPE device row shows after its router is assigned: the router
 * and its datacenter, or that nothing changed.
 */
export const assignmentResultText = (result: CpeRouterAssignment): string => {
  const where = result.router.datacenterId ? ` (${result.router.datacenterId})` : "";
  return result.changed
    ? `Assigned ${result.router.hostname}${where}. Its Backhaul legs are derived from this router now.`
    : `${result.router.hostname}${where} was already this device's router.`;
};

/** A hostname worth sending: trimmed, not blank. */
export const cleanHostname = (value: string): string | null => {
  const hostname = value.trim();
  return hostname ? hostname : null;
};
